// NEW-93 (2026-09-12): opt-in "Remember my email on this device" toggle in AccountPanel;
//   sets the login_hint pre-fill. Version bump TBD by Sophie on review.
// pages/SettingsPage.jsx — Anamoria SPA
// v3.18 — Phase 2: pass canSetGroupType (group_spaces_enabled && leader) to SpaceInfoPanel
//   so the Space panel can show the space-type switch. (Sept 3, 2026)
// v3.17 — overlay polish: in overlay mode, remove both back-links (page-header +
//   sidebar 'space back'), add an X close (top-right) that closes the overlay, and
//   the mobile menu fills the screen (drawer full-width, no scrim). All gated on
//   inOverlay; full-page /settings keeps its back-links unchanged.
// v3.16 — settings_overlay (PR1): additive `inOverlay` prop. When true the root
//   .page fills its host panel (.pageInOverlay: height 100%) instead of 100vh, so
//   SettingsPage can be hosted inside <SettingsOverlay>. Default false ⇒ byte-
//   identical full-page render. No other behaviour change.
// v3.15 - Settings IA (B): desktop opens a default section instead of a blank pane.
//   On /settings with no ?section, on a desktop viewport (>640px, matching the .leftNav
//   breakpoint) default activeSection to the space (space-info when a space is in context,
//   else account) and do NOT auto-open the mobile drawer. Mobile (<=640px) unchanged
//   (menu-first). Fixes the footer-gear 'blank screen right of the sidebar' on desktop.
//   Plan: settings-ia-fix-plan-DRAFT-for-review-v0.1.md. (2026-08-30)
// v3.14 — 4.3: Recently Deleted shows moment entries (cover + piece count) and
//   relabels to the "Remove/Removed" register; "trash"/emoji retired
//   (July 24, 2026). Plan v0.12, copy v0.12 §1b. The moments-trash fetch is
//   gated on moments_enabled; memory-only behaviour is byte-identical when off.
// v3.13 — Recently Deleted: BrandIcons replace emojis (June 27, 2026)
// Changes from v3.12:
//   - CATEGORY_ICONS: replaced emoji map (🎤, ✏️, 📷, 🎬) with BrandIcons
//     SVG components (RecordIcon, WriteIcon, PhotoIcon, VideoIcon at 16px).
//     Matches the icon set used in BottomNav and SuccessScreen throughout
//     the app. Fallback for unknown categories uses WriteIcon.
//   - Added BrandIcons import.
//   - No other changes.
//
// v3.12 — Settings gear lands on category list, not space-info (June 23, 2026)
// Changes from v3.11 (one line):
//   - resolveInitialSection: returns null (no section pre-selected) when no
//     explicit section param in URL. Previously returned 'space-info' when
//     hasSpaceId, which pre-highlighted Space Info in the sidebar and rendered
//     the space-info panel behind the overlay. Now the sidebar opens as a clean
//     category list with nothing selected. Matches iOS/Android/Gmail/Slack
//     pattern: generic settings entry point → navigation list. Sidebar dismiss
//     without selection still navigates back (unchanged from v3.8).
//   - No other changes.
//
// v3.11 — Privacy Policy link in consent section (June 14, 2026)
// Changes from v3.10 (additive — one import, one link; no logic/state change):
//   - Imported Link from react-router-dom.
//   - AccountPanel "Your consent" hint now ends with an in-app "View the
//     Privacy Policy." link to /privacy (same tab — Settings has no transient
//     state, and LegalPage's Back returns here). Adds .privacyPolicyLink to
//     the CSS module.
//
// v3.10 — Hide billing nav when billingEnabled is false (May 26, 2026)
// Changes from v3.9:
//   - globalNavItems: billing nav item conditionally excluded when
//     billing.billingEnabled is false (feature flag from backend).
//   - Zero changes to all other settings panels, nav items, or rendering.
//
// v3.9 — Suggestions panel: enabled nav item, lightbulb icon, renderPanel,
//         excludeTypes on existing RequestPanel usages (May 23, 2026)
// Changes from v3.8:
//   - NEW SuggestionsIcon component (lightbulb SVG, 16px, stroke 1.5).
//     Replaces FeedbackIcon in quickActionItems. FeedbackIcon retained
//     for potential future use.
//   - quickActionItems: 'feedback' item (disabled, coming soon) replaced
//     with 'suggestions' item (enabled, SuggestionsIcon, no hint).
//   - TYPE_LABELS_SHORT: added 'suggestion' entry.
//   - getSummaryLine: added 'suggestion' case.
//   - resolveInitialSection: 'feedback' maps to 'suggestions' (backward compat).
//   - renderPanel: added 'suggestions' case rendering SuggestionsPanel.
//   - Import: SuggestionsPanel from ../components/settings/SuggestionsPanel.
//   - RequestPanel usages in 'request' and 'need-help' cases: added
//     excludeTypes={['suggestion']} prop.
//   - No other changes.
//
// v3.8 — Settings sidebar auto-opens on arrival (May 22, 2026)
// Changes from v3.7:
//   - settingsSidebarOpen: initializes to true when no explicit section param
//     in URL. User sees category list overlay on arrival. Space-info panel
//     renders behind it (unchanged default). Per iOS/Android/Gmail/Slack
//     settings pattern: generic settings entry point → category list.
//   - closeSettingsSidebar: when user arrived without section param and
//     dismisses sidebar without selecting, navigate(-1) returns to previous
//     page instead of showing settings panel.
//   - resolveInitialSection: unchanged (space-info when hasSpaceId, account otherwise).
//   - No other changes.
//
// v3.7 — Settings section reorganization: Global / Space / Quick Actions (May 20, 2026)
// Changes from v3.6:
//   - navItems restructured with section property: globalNavItems (account,
//     security, billing), spaceNavItems (space-info, contributors, reminders,
//     recently-deleted), quickActionItems (need-help, app-tour, feedback).
//   - NEW TourIcon, FeedbackIcon inline SVG components (16px, outlined).
//   - "GLOBAL" section header added above Account/Security/Billing.
//   - "QUICK ACTIONS" section header added above Need Help/App Tour/Feedback.
//   - Recently Deleted moved up (under Reminders in SPACE section).
//   - Need Help moved from SPACE to QUICK ACTIONS (not space-specific).
//   - Feedback nav item: aria-disabled="true", "(coming soon)" hint.
//   - App Tour nav item: placeholder panel with "Start tour" button (wired in Session C).
//   - isSpacePanel: removed 'need-help' (doesn't require space loading gate).
//   - Section-boundary rendering replaces isFirstSpaceItem check. ARIA id attrs on headers.
//   - Same changes mirrored in mobile sidebar.
//   - Sign Out remains pinned to bottom (unchanged).
//
// v3.6 — Space photo in backlink (May 20, 2026)
// Changes from v3.5:
//   - Added resolvedSpacePhotoUrl state + useEffect to resolve space.photoUrl
//     to CloudFront signed URL (same pattern as SpacePage v2.17).
//   - Desktop backlink: space photo (24px circle) between arrow and name.
//     Falls back to letter initial. onError handler for broken images (BP-1).
//   - Mobile sidebar backlink: same treatment (28px circle).
//   - No logic changes. No panel changes. No nav changes.
//
// v3.5 — Security panel: PIN set/change/remove + lock timeout (May 18, 2026)
// Changes from v3.4:
//   - NEW ShieldIcon component (shield SVG, 16x16, stroke 1.5).
//   - NEW 'security' nav item between Account and Plan & Billing.
//   - NEW SecurityPanel inline component: fetches security settings,
//     renders PIN management (set/change/remove via PinSetup) and
//     lock timeout dropdown (PATCH /security/settings).
//   - NEW renderPanel case for 'security'.
//   - Import PinSetup component from ../components/PinSetup.
//   - Consumes updateSecuritySettings from context to sync App.jsx lock state.
//   - Zero changes to existing panels, nav logic, or sidebar behavior.
//
// v3.4 — Recently Deleted: trash panel in Settings (May 17, 2026)
// Changes from v3.3:
//   - NEW TrashIcon component (trash can SVG, 16x16, stroke 1.5).
//   - NEW 'recently-deleted' nav item in spaceNavItems (after need-help).
//   - NEW RecentlyDeletedPanel inline component: fetches trashed memories
//     from GET /spaces/:id/memories/trash, renders list with category icon,
//     title, deletion date, days remaining, and Restore button.
//     Restore calls POST /memories/:id/restore.
//   - NEW renderPanel case for 'recently-deleted'.
//   - isSpacePanel list updated to include 'recently-deleted'.
//   - Zero changes to existing panels, nav logic, or sidebar behavior.
//
// v3.3 — Mobile settings sidebar: slide-out section menu (May 16, 2026)
// Changes from v3.2:
//   - Mobile navigation changed from horizontal tab strip to slide-out
//     sidebar matching the SpacePage "Your Memory Spaces" pattern.
//   - Menu button (☰) in header opens sidebar overlay with vertical
//     section list. Tapping a section closes sidebar and shows content.
//   - Added settingsSidebarOpen state and toggleSettingsSidebar.
//   - Header shows menu button on mobile (hidden on desktop via CSS).
//   - Sidebar + backdrop rendered at page level, same z-index pattern
//     as SpacePage sidebar.
//   - Desktop layout completely unchanged — side-by-side nav + panel.
//
// v3.2 — Wrap request + request-success cases in .panel container (May 2, 2026)
// Changes from v3.1:
//   - case 'request' now wraps RequestPanel in <div className={styles.panel}>
//     with <h2>Submit a Request</h2> heading. Previously rendered without
//     wrapper, causing the form to span the full rightPanel width and
//     mismatch the Need Help variant.
//   - case 'request-success' now wraps RequestSuccessPanel in
//     <div className={styles.panel}>. No heading added — the success panel
//     has its own internal "Request received" heading.
//   - No other changes.
//
// v3.1 — BUX-1: Payment history includes Lifetime (PaymentIntent) payments (May 1, 2026)
// Changes from v3.0:
//   - Section header renamed "Your invoices" → "Payment history"
//   - Invoice rows now show description text from backend (e.g., "Lifetime membership upgrade")
//   - Download link: "PDF" for subscription invoices, "Receipt" for one-time payments
//   - Backend get-invoices.mjs v2.0 now returns both invoices and PaymentIntents
//
// v3.0 — Forever tier billing panel: payment method, full invoices, Change plan (May 1, 2026)
// Changes from v2.9:
//   - Forever tier BillingPanel now shows full billing sections:
//     Plan card with "Change plan" link, Payment method with Update,
//     and full invoices list (not just first invoice).
//     Previously showed minimal view with plan card + single invoice only.
//   - UpdatePaymentModal renders for forever tier (already rendered for premium).
//   - No "Manage subscription" section for forever (no subscription to manage).
//
// v2.9 — UI polish: Need Help goes directly to request form (April 29, 2026)
// Changes from v2.8:
//   - 'need-help' case now renders RequestPanel directly with title + subtitle
//     header, instead of the interim NeedHelpPanel landing page that just
//     showed a "Submit a request" button. Eliminates one unnecessary click.
//   - NeedHelpPanel import retained but no longer rendered (stable import path).
//   - No other changes.
//
// v2.8 — Phase D: AccountPanel pending list + cancel + view all (April 21, 2026)
// Changes from v2.7:
//   - AccountPanel Requests section expanded with inline pending list
//   - Per-row Cancel with inline confirmation (not modal)
//   - "View all requests →" link to /settings/my-requests
//   - Fetches GET /account-requests/me on AccountPanel mount
//   - TYPE_LABELS_SHORT constant for pending list display
//   - navigate import used for "View all requests" link
//
//   All other panels, icons, resolveInitialSection: UNCHANGED
//
// URL: /settings?from={spaceId}&section={sectionId}&action={action}

import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient } from '../api/client';
import { useAppContext } from '../App';
import { useBillingStatus, getPlanLabel } from '../hooks/useBillingStatus';
import SpaceInfoPanel from '../components/settings/SpaceInfoPanel';
import ContributorsPanel from '../components/settings/ContributorsPanel';
import RemindersPanel from '../components/settings/RemindersPanel';
import NeedHelpPanel from '../components/settings/NeedHelpPanel';
import RequestPanel from '../components/settings/RequestPanel';
import RequestSuccessPanel from '../components/settings/RequestSuccessPanel';
import SuggestionsPanel from '../components/settings/SuggestionsPanel';
import PinSetup from '../components/PinSetup';
import UpdatePaymentModal from '../components/billing/UpdatePaymentModal';
import CancelModal from '../components/billing/CancelModal';
import PauseModal from '../components/billing/PauseModal';
import SwitchPlanModal from '../components/billing/SwitchPlanModal';
import { RecordIcon, WriteIcon, PhotoIcon, VideoIcon } from '../components/BrandIcons';
import styles from './SettingsPage.module.css';
import shared from '../components/settings/settingsShared.module.css';
import { isRemembering, setRemembering } from '../utils/rememberEmail';

/* ─── Icons (unchanged from v2.0) ─── */

function BackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 5l-7 7 7 7" />
    </svg>
  );
}

function BillingIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="3" />
      <path d="M2 10h20" />
    </svg>
  );
}

function SpaceIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  );
}

function ContributorsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

function ReminderIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

function AccountIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}

function SignOutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}

/* v2.7: Phase C — danger zone warning icon */
function WarningTriangleIcon({ className, ...rest }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round"
         className={className} aria-hidden="true" {...rest}>
      <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    </svg>
  );
}

/* v3.4: Recently Deleted — trash can icon */
function TrashIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  );
}

/* v3.5: Shield icon for Security nav item */
function ShieldIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l8 4v6c0 5.25-3.5 9.75-8 11-4.5-1.25-8-5.75-8-11V6l8-4z" />
    </svg>
  );
}

/* v3.7: Tour icon (compass) for App Tour nav item */
function TourIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </svg>
  );
}

/* v3.7: Feedback icon (message bubble) for Feedback nav item */
function FeedbackIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

/* v3.9: Suggestions icon (lightbulb) for Suggestions nav item */
function SuggestionsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z" />
    </svg>
  );
}

/* ═══════════════════════════════════════
   ACCOUNT PANEL — v2.8 (Phase D: +pending list, +cancel, +view all)
   Sign Out in sidebar. Email link in identity card.
   ═══════════════════════════════════════ */

const TYPE_LABELS_SHORT = {
  deletion: 'Account Deletion',
  export: 'Data Export',
  email_change: 'Email Change',
  other: 'Support Request',
  suggestion: 'Suggestion',
};

function getSummaryLine(requestType, metadata) {
  if (!metadata) return '';
  switch (requestType) {
    case 'deletion':
      return metadata.reason ? metadata.reason.substring(0, 60) + (metadata.reason.length > 60 ? '…' : '') : '';
    case 'export':
      return '';
    case 'email_change':
      return metadata.new_email || '';
    case 'other':
      return metadata.subject || '';
    case 'suggestion':
      return metadata.subject || '';
    default:
      return '';
  }
}

function AccountPanel({ user, appState, getApi, onOpenRequest }) {
  const { updateProfile } = useAppContext();
  const navigate = useNavigate();  // v2.8: for "View all requests" link

  // ─── Name display values ───
  const userName  = appState?.displayName || user?.name  || 'Your account';
  const userEmail = appState?.email || user?.email || '';

  // ─── Name edit state ───
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [editError, setEditError] = useState(null);
  const [justSaved, setJustSaved] = useState(false);

  // NEW-93: opt-in "Remember my email on this device" (device-local pre-fill).
  const [rememberEmail, setRememberEmail] = useState(() => isRemembering());
  const handleToggleRememberEmail = () => {
    const next = !rememberEmail;
    setRememberEmail(next);
    setRemembering(next, userEmail);
  };

  const editBtnRef = useRef(null);
  const inputRef = useRef(null);
  const savedTimerRef = useRef(null);

  // v2.8: Pending requests state
  const [pendingRequests, setPendingRequests] = useState([]);
  const [pendingLoading, setPendingLoading] = useState(true);
  const [confirmingId, setConfirmingId] = useState(null);
  const [cancellingId, setCancellingId] = useState(null);
  const [cancelError, setCancelError] = useState(null);

  // Fetch pending requests on mount
  useEffect(() => {
    async function loadRequests() {
      try {
        const api = getApi();
        const data = await api.get('/account-requests/me');
        const pending = (data.requests || []).filter(
          r => r.status === 'pending' || r.status === 'in_progress'
        );
        setPendingRequests(pending);
      } catch (err) {
        console.error('AccountPanel: requests fetch failed:', err);
      } finally {
        setPendingLoading(false);
      }
    }
    loadRequests();
  }, [getApi]);

  // Cancel handler
  async function handleCancelRequest(requestId) {
    setCancellingId(requestId);
    setCancelError(null);
    try {
      const api = getApi();
      await api.patch(`/account-requests/${requestId}`, { status: 'cancelled' });
      setPendingRequests(prev => prev.filter(r => r.requestId !== requestId));
      setConfirmingId(null);
    } catch (err) {
      const messages = {
        NOT_CANCELLABLE: 'This request can no longer be cancelled.',
        REQUEST_NOT_FOUND: 'Request not found.',
      };
      setCancelError(messages[err?.error] || 'Could not cancel. Please try again.');
    } finally {
      setCancellingId(null);
    }
  }

  // Focus input when entering edit mode
  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  // Cleanup saved timer on unmount
  useEffect(() => {
    return () => {
      if (savedTimerRef.current) clearTimeout(savedTimerRef.current);
    };
  }, []);

  function handleStartEdit() {
    setEditValue(userName === 'Your account' ? '' : userName);
    setEditError(null);
    setJustSaved(false);
    setEditing(true);
  }

  function handleCancelEdit() {
    setEditing(false);
    setEditError(null);
    requestAnimationFrame(() => editBtnRef.current?.focus());
  }

  async function handleSaveName() {
    const trimmed = editValue.trim();

    if (trimmed.length === 0) {
      setEditError('Name cannot be empty.');
      return;
    }
    if (trimmed.length > 100) {
      setEditError('Name must be 100 characters or fewer.');
      return;
    }

    setSaving(true);
    setEditError(null);

    try {
      const api = getApi();
      const updated = await api.patch('/pilot/me', { displayName: trimmed });
      updateProfile({ displayName: updated.displayName });
      setEditing(false);
      setJustSaved(true);
      savedTimerRef.current = setTimeout(() => setJustSaved(false), 2000);
      requestAnimationFrame(() => editBtnRef.current?.focus());
    } catch (err) {
      const errorMessages = {
        DISPLAY_NAME_EMPTY: 'Name cannot be empty.',
        DISPLAY_NAME_TOO_LONG: 'Name must be 100 characters or fewer.',
        UNSUPPORTED_FIELD: 'Could not save — unsupported field.',
        USER_NOT_FOUND: 'Account not found. Please refresh and try again.',
      };
      setEditError(errorMessages[err?.error] || 'Could not save. Please try again.');

      if (!err?.status || err.status >= 500) {
        try {
          const api = getApi();
          await api.postPublic('/errors', {
            error: 'PROFILE_UPDATE_FAILED',
            detail: err?.message || err?.error || 'unknown',
            timestamp: new Date().toISOString(),
          });
        } catch (_) { /* telemetry best-effort */ }
      }
    } finally {
      setSaving(false);
    }
  }

  function handleEditKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); handleSaveName(); }
    if (e.key === 'Escape') { e.preventDefault(); handleCancelEdit(); }
  }

  // ─── Consent display ───
  const consentDate = appState?.consentDate;
  const consentPolicyVersion = appState?.consentPolicyVersion;

  function formatConsentDate(isoString) {
    if (!isoString) return null;
    return new Date(isoString).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric',
    });
  }

  return (
    <div className={styles.panel}>
      {/* ── Section 1: Heading ── */}
      <h2 className={styles.panelTitle}>Account</h2>

      {/* ── Section 2: Identity card (name + email + links) ── */}
      <div className={styles.accountCard}>
        <div className={styles.accountAvatar}>
          {(appState?.displayName || userName).charAt(0).toUpperCase()}
        </div>
        <div className={styles.accountInfo}>
          {!editing ? (
            <>
              <span className={styles.accountName}>
                {userName}
                {justSaved && (
                  <span className={styles.savedMark} aria-live="polite"> Saved ✓</span>
                )}
              </span>
              <span className={styles.accountEmail}>{userEmail}</span>
              <div className={styles.identityLinks}>
                <button
                  ref={editBtnRef}
                  className={styles.editNameLink}
                  onClick={handleStartEdit}
                >
                  Edit name
                </button>
                <span className={styles.identityLinkSep}>·</span>
                <button
                  className={styles.editNameLink}
                  onClick={() => onOpenRequest('email_change')}
                >
                  Change my email
                </button>
              </div>
            </>
          ) : (
            <>
              <span className={styles.accountEmail}>{userEmail}</span>
              <div className={styles.editNameRow}>
                <input
                  ref={inputRef}
                  className={styles.editNameInput}
                  type="text"
                  value={editValue}
                  onChange={(e) => setEditValue(e.target.value)}
                  onKeyDown={handleEditKeyDown}
                  maxLength={100}
                  aria-label="Display name"
                  aria-invalid={editError ? 'true' : 'false'}
                  aria-describedby={editError ? 'name-edit-error' : undefined}
                  disabled={saving}
                />
                <div className={styles.editNameActions}>
                  <button className={styles.editNameSave} onClick={handleSaveName} disabled={saving}>
                    {saving ? 'Saving…' : 'Save'}
                  </button>
                  <button className={styles.editNameCancel} onClick={handleCancelEdit} disabled={saving}>
                    Cancel
                  </button>
                </div>
              </div>
              {editError && (
                <p id="name-edit-error" className={styles.editNameError} role="alert">
                  {editError}
                </p>
              )}
            </>
          )}
        </div>
      </div>

      {/* ── Section: Signing in (NEW-93 opt-in email pre-fill) ── */}
      <div className={styles.accountSection}>
        <span className={styles.accountSectionTitle}>Signing in</span>
        <div
          className={shared.toggleRow}
          onClick={handleToggleRememberEmail}
          role="switch"
          aria-checked={rememberEmail}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleToggleRememberEmail();
            }
          }}
        >
          <div className={shared.toggleRowLeft}>
            <span className={shared.toggleLabel} style={{ opacity: rememberEmail ? 1 : 0.5 }}>
              Remember my email on this device
            </span>
          </div>
          <div className={`${shared.toggleTrack} ${rememberEmail ? shared.toggleOn : ''}`}>
            <div className={shared.toggleKnob} />
          </div>
        </div>
      </div>

      {/* ── Section 3: Consent ── */}
      <div className={styles.accountSection}>
        <span className={styles.accountSectionTitle}>Your consent</span>
        <span className={styles.accountSectionValue}>
          {consentDate
            ? `Consented on ${formatConsentDate(consentDate)} · Policy v${consentPolicyVersion}`
            : 'No consent record on file.'
          }
        </span>
        <span className={styles.accountSectionHint}>
          A record of what you agreed to when you joined.
          To withdraw your consent, request account deletion below.{' '}
          <Link to="/privacy" className={styles.privacyPolicyLink}>
            View the Privacy Policy.
          </Link>
        </span>
      </div>

      {/* ── Section 4: Requests (v2.8: +pending list, +cancel, +view all) ── */}
      <div className={styles.accountSection}>
        <span className={styles.accountSectionTitle}>Requests</span>
        <button
          className={styles.contactSupportLink}
          onClick={() => onOpenRequest('other')}
        >
          Submit a request
        </button>

        {/* Pending requests inline list */}
        {!pendingLoading && pendingRequests.length > 0 && (
          <div className={styles.pendingRequestsList}>
            {pendingRequests.map(r => {
              const summary = getSummaryLine(r.requestType, r.metadata);
              return (
                <div key={r.requestId} className={styles.pendingRequestRow}>
                  <div className={styles.pendingRequestInfo}>
                    <span className={styles.requestTypeLabel}>
                      {TYPE_LABELS_SHORT[r.requestType] || r.requestType}
                    </span>
                    {summary && (
                      <span className={styles.pendingRequestSummary}>{summary}</span>
                    )}
                  </div>
                  <span className={`${styles.requestStatusBadge} ${
                    r.status === 'pending' ? styles.badgePending : styles.badgeInProgress
                  }`}>
                    {r.status === 'in_progress' ? 'In progress' : 'Pending'}
                  </span>

                  {/* Cancel or confirmation */}
                  {confirmingId !== r.requestId ? (
                    <button className={styles.pendingCancelBtn}
                      onClick={() => { setConfirmingId(r.requestId); setCancelError(null); }}>
                      Cancel
                    </button>
                  ) : (
                    <div className={styles.pendingCancelConfirm}>
                      <button className={styles.pendingCancelConfirmYes}
                        onClick={() => handleCancelRequest(r.requestId)}
                        disabled={cancellingId === r.requestId}>
                        {cancellingId === r.requestId ? '…' : 'Cancel request'}
                      </button>
                      <button className={styles.pendingCancelConfirmNo}
                        onClick={() => setConfirmingId(null)}>
                        Never mind
                      </button>
                    </div>
                  )}

                  {cancelError && confirmingId === r.requestId && (
                    <span className={styles.pendingCancelError}>{cancelError}</span>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {!pendingLoading && pendingRequests.length === 0 && (
          <span className={styles.pendingRequestsEmpty}>
            You have no pending requests.
          </span>
        )}

        {/* v2.9: Only show "View all requests" when there are requests to view */}
        {pendingRequests.length > 0 && (
          <button
            className={styles.viewAllRequestsLink}
            onClick={() => {
              const fromParam = new URLSearchParams(window.location.search).get('from');
              navigate(fromParam ? `/settings/my-requests?from=${fromParam}` : '/settings/my-requests');
            }}
          >
            View all requests →
          </button>
        )}
      </div>

      {/* ── Section 5: Delete account danger zone ── */}
      <div className={styles.dangerZone}>
        <div className={styles.dangerZoneHeading}>
          <WarningTriangleIcon className={styles.dangerZoneIcon} />
          <h3 className={styles.dangerZoneTitle}>Delete account</h3>
        </div>
        <p className={styles.dangerZoneBody}>
          Request permanent deletion of your account and all your memories.
          This action is irreversible.
        </p>
        <button
          className={styles.dangerBtn}
          onClick={() => onOpenRequest('deletion')}
        >
          Request Account Deletion
        </button>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════
   BILLING PANEL — v2.4 (auto-open CancelModal from URL param)
   ═══════════════════════════════════════ */

function BillingPanel({ spaceId, navigate, getApi, initialAction }) {
  const { billing, loading, error, refetch } = useBillingStatus(getApi);
  const [invoices, setInvoices]   = useState([]);
  const [invoicesLoading, setInvoicesLoading] = useState(false);

  // v2.2: Modal visibility state
  const [showUpdatePayment, setShowUpdatePayment] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showPause, setShowPause] = useState(false);
  const [showSwitchPlan, setShowSwitchPlan] = useState(false);
  const [pausePreselectedMonths, setPausePreselectedMonths] = useState(null);

  // v2.2: Reactivate / Resume loading states
  const [reactivating, setReactivating] = useState(false);
  const [resuming, setResuming] = useState(false);

  useEffect(() => {
    if (initialAction === 'cancel' && billing && !loading) {
      if (billing.tier === 'premium' && !billing.cancelAtPeriodEnd) {
        setShowCancel(true);
      }
    }
  }, [initialAction, billing, loading]);

  useEffect(() => {
    if (!billing || billing.tier === 'free') return;
    async function loadInvoices() {
      setInvoicesLoading(true);
      try {
        const api = getApi();
        const data = await api.get('/billing/invoices');
        setInvoices(data.invoices || []);
      } catch (err) {
        console.error('BillingPanel: invoices fetch failed:', err);
      } finally {
        setInvoicesLoading(false);
      }
    }
    loadInvoices();
  }, [billing, getApi]);

  function goUpgrade() {
    const billingUrl = spaceId
      ? `/settings?from=${spaceId}&section=billing`
      : '/settings?section=billing';
    window.history.replaceState(null, '', billingUrl);
    const q = spaceId ? `?from=${spaceId}` : '';
    navigate(`/settings/upgrade${q}`);
  }

  function formatDate(isoString) {
    if (!isoString) return '—';
    return new Date(isoString).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric',
    });
  }

  function formatAmount(cents) {
    if (cents == null) return '—';
    return `$${(cents / 100).toFixed(2)}`;
  }

  function capitalizeFirst(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  async function handleReactivate() {
    setReactivating(true);
    try {
      const api = getApi();
      await api.post('/billing/subscription/reactivate');
      refetch();
    } catch (err) {
      console.error('Reactivate error:', err);
    } finally {
      setReactivating(false);
    }
  }

  async function handleResumeEarly() {
    setResuming(true);
    try {
      const api = getApi();
      await api.delete('/billing/subscription/pause');
      refetch();
    } catch (err) {
      console.error('Resume early error:', err);
    } finally {
      setResuming(false);
    }
  }

  function handleOpenPauseFromCancel(months) {
    setPausePreselectedMonths(months);
    setShowPause(true);
  }

  if (loading) {
    return (
      <div className={styles.panel}>
        <h2 className={styles.panelTitle}>Plan &amp; Billing</h2>
        <p className={styles.panelLoading}>Loading billing info…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.panel}>
        <h2 className={styles.panelTitle}>Plan &amp; Billing</h2>
        <div className={styles.billingError}>
          <p>Couldn't load billing information.</p>
          <button className={styles.retryBtn} onClick={refetch}>Try again</button>
        </div>
      </div>
    );
  }

  const tier = billing?.tier || 'free';
  const planLabel = getPlanLabel(billing);

  if (tier === 'free') {
    return (
      <div className={styles.panel}>
        <h2 className={styles.panelTitle}>Plan &amp; Billing</h2>
        <div className={styles.planCard}>
          <div className={styles.planCardLeft}>
            <span className={styles.planName}>{planLabel}</span>
            <span className={styles.planLimits}>Up to 15 memories · 1 space</span>
          </div>
          <button className={styles.upgradeBtn} onClick={goUpgrade}>Upgrade</button>
        </div>
        <p className={styles.panelHint}>Your memories are always kept, whatever plan you're on.</p>
      </div>
    );
  }

  if (tier === 'forever') {
    return (
      <div className={styles.panel}>
        <h2 className={styles.panelTitle}>Plan &amp; Billing</h2>

        <div className={styles.planCard}>
          <div className={styles.planCardLeft}>
            <span className={styles.planName}>Lifetime Member ♾</span>
            <span className={styles.planLimits}>Member since {formatDate(billing.foreverPurchasedAt)}</span>
          </div>
          <button className={styles.changePlanLink} onClick={goUpgrade}>Change plan</button>
        </div>

        {billing.cardBrand && billing.cardLast4 && (
          <div className={styles.billingSection}>
            <h3 className={styles.billingSectionTitle}>Payment method</h3>
            <div className={styles.cardInfo}>
              <span className={styles.cardBrand}>{capitalizeFirst(billing.cardBrand)}</span>
              <span className={styles.cardLast4}>ending in {billing.cardLast4}</span>
              <button className={styles.cardUpdateLink} onClick={() => setShowUpdatePayment(true)}>Update</button>
            </div>
          </div>
        )}

        {invoicesLoading ? (
          <div className={styles.billingSection}>
            <h3 className={styles.billingSectionTitle}>Payment history</h3>
            <p className={styles.panelLoading}>Loading payment history…</p>
          </div>
        ) : invoices.length > 0 ? (
          <div className={styles.billingSection}>
            <h3 className={styles.billingSectionTitle}>Payment history</h3>
            <div className={styles.invoiceList}>
              {invoices.map((inv) => (
                <div key={inv.id} className={styles.invoiceRow}>
                  <span className={styles.invoiceDate}>{formatDate(inv.date)}</span>
                  <span className={styles.invoiceAmount}>{formatAmount(inv.amount)}</span>
                  <span className={styles.invoiceStatus}>{inv.description || inv.status}</span>
                  {inv.pdfUrl ? (
                    <a href={inv.pdfUrl} target="_blank" rel="noopener noreferrer" className={styles.invoiceLink}>
                      <DownloadIcon /> PDF
                    </a>
                  ) : inv.receiptUrl ? (
                    <a href={inv.receiptUrl} target="_blank" rel="noopener noreferrer" className={styles.invoiceLink}>
                      <DownloadIcon /> Receipt
                    </a>
                  ) : (
                    <span className={styles.invoiceLink} />
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : null}

        <p className={styles.panelHint}>You have lifetime access to Anamoria. No recurring charges.</p>

        {showUpdatePayment && (
          <UpdatePaymentModal isOpen onClose={() => setShowUpdatePayment(false)} getApi={getApi} onSuccess={refetch} />
        )}
      </div>
    );
  }

  // Premium tier
  return (
    <div className={styles.panel}>
      <h2 className={styles.panelTitle}>Plan &amp; Billing</h2>

      {billing.paymentFailed && (
        <div className={`${styles.warningBanner} ${billing.paymentFailedUrgent ? styles.warningBannerUrgent : ''}`}>
          <p className={styles.warningText}>There's a problem with your payment — update your card to keep your access.</p>
          <button className={styles.warningAction} onClick={() => setShowUpdatePayment(true)}>Update card</button>
        </div>
      )}

      {billing.cancelAtPeriodEnd && (
        <div className={styles.cancelNotice}>
          <p className={styles.cancelNoticeText}>
            Your plan moves to Free on {formatDate(billing.currentPeriodEnd)}. Your memories stay accessible.
          </p>
          <button className={styles.cancelNoticeAction} onClick={handleReactivate} disabled={reactivating}>
            {reactivating ? 'Reactivating…' : 'Reactivate'}
          </button>
        </div>
      )}

      {billing.pauseCollectionUntil && (
        <div className={styles.pauseNotice}>
          <p className={styles.pauseNoticeText}>
            Billing paused until {formatDate(billing.pauseCollectionUntil)}. Your memories stay accessible.
          </p>
          <button className={styles.pauseNoticeAction} onClick={handleResumeEarly} disabled={resuming}>
            {resuming ? 'Resuming…' : 'Resume early'}
          </button>
        </div>
      )}

      <div className={styles.planCard}>
        <div className={styles.planCardLeft}>
          <span className={styles.planName}>{planLabel}</span>
          <span className={styles.planLimits}>
            {billing.cancelAtPeriodEnd
              ? `Access until ${formatDate(billing.currentPeriodEnd)}`
              : `Renews ${formatDate(billing.currentPeriodEnd)}`}
          </span>
        </div>
        <button className={styles.changePlanLink} onClick={goUpgrade}>Change plan</button>
      </div>

      {billing.cardBrand && billing.cardLast4 && (
        <div className={styles.billingSection}>
          <h3 className={styles.billingSectionTitle}>Payment method</h3>
          <div className={styles.cardInfo}>
            <span className={styles.cardBrand}>{capitalizeFirst(billing.cardBrand)}</span>
            <span className={styles.cardLast4}>ending in {billing.cardLast4}</span>
            <button className={styles.cardUpdateLink} onClick={() => setShowUpdatePayment(true)}>Update</button>
          </div>
        </div>
      )}

      <div className={styles.billingSection}>
        <h3 className={styles.billingSectionTitle}>Manage subscription</h3>
        <div className={styles.managementLinks}>
          <button className={styles.managementLink} onClick={() => setShowSwitchPlan(true)}>
            Switch to {billing.billingPeriod === 'monthly' ? 'Annual' : 'Monthly'}
          </button>
          {!billing.pauseCollectionUntil && !billing.cancelAtPeriodEnd && (
            <button className={styles.managementLink} onClick={() => { setPausePreselectedMonths(null); setShowPause(true); }}>
              Pause subscription
            </button>
          )}
          {!billing.cancelAtPeriodEnd && (
            <button className={styles.managementLink} onClick={() => setShowCancel(true)}>
              Downgrade to Free
            </button>
          )}
        </div>
      </div>

      {invoicesLoading ? (
        <div className={styles.billingSection}>
          <h3 className={styles.billingSectionTitle}>Payment history</h3>
          <p className={styles.panelLoading}>Loading payment history…</p>
        </div>
      ) : invoices.length > 0 ? (
        <div className={styles.billingSection}>
          <h3 className={styles.billingSectionTitle}>Payment history</h3>
          <div className={styles.invoiceList}>
            {invoices.map((inv) => (
              <div key={inv.id} className={styles.invoiceRow}>
                <span className={styles.invoiceDate}>{formatDate(inv.date)}</span>
                <span className={styles.invoiceAmount}>{formatAmount(inv.amount)}</span>
                <span className={styles.invoiceStatus}>{inv.description || inv.status}</span>
                {inv.pdfUrl ? (
                  <a href={inv.pdfUrl} target="_blank" rel="noopener noreferrer" className={styles.invoiceLink}>
                    <DownloadIcon /> PDF
                  </a>
                ) : inv.receiptUrl ? (
                  <a href={inv.receiptUrl} target="_blank" rel="noopener noreferrer" className={styles.invoiceLink}>
                    <DownloadIcon /> Receipt
                  </a>
                ) : (
                  <span className={styles.invoiceLink} />
                )}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <p className={styles.panelHint}>Your memories are always kept, whatever plan you're on.</p>

      {showUpdatePayment && (
        <UpdatePaymentModal isOpen onClose={() => setShowUpdatePayment(false)} getApi={getApi} onSuccess={refetch} />
      )}
      {showCancel && (
        <CancelModal isOpen onClose={() => setShowCancel(false)} billing={billing} getApi={getApi}
          onSuccess={refetch} onOpenPause={handleOpenPauseFromCancel} />
      )}
      {showPause && (
        <PauseModal isOpen onClose={() => { setShowPause(false); setPausePreselectedMonths(null); }}
          getApi={getApi} onSuccess={refetch} preselectedMonths={pausePreselectedMonths} />
      )}
      {showSwitchPlan && (
        <SwitchPlanModal isOpen onClose={() => setShowSwitchPlan(false)} billing={billing}
          getApi={getApi} onSuccess={refetch} />
      )}
    </div>
  );
}

/* ═══════════════════════════════════════
   SECURITY PANEL — v3.5
   PIN management (set/change/remove) + lock timeout dropdown.
   Fetches GET /security/settings on mount.
   Calls updateSecuritySettings to sync App.jsx lock state.
   ═══════════════════════════════════════ */

const LOCK_TIMEOUT_OPTIONS = [
  { value: 60,   label: '1 minute' },
  { value: 120,  label: '2 minutes' },
  { value: 300,  label: '5 minutes' },
  { value: 900,  label: '15 minutes' },
  { value: 1800, label: '30 minutes' },
];

function SecurityPanel({ getApi }) {
  const { updateSecuritySettings } = useAppContext();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pinMode, setPinMode] = useState(null); // null | 'set' | 'change'
  const [removing, setRemoving] = useState(false);
  const [confirmRemove, setConfirmRemove] = useState(false);
  const [timeoutSaving, setTimeoutSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);

  // Fetch security settings on mount
  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const api = getApi();
        const data = await api.get('/security/settings');
        if (!cancelled) setSettings(data);
      } catch (err) {
        console.error('Security settings load error:', err);
        if (!cancelled) setError('Could not load security settings.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [getApi]);

  // PIN set/change success
  function handlePinSuccess() {
    setSettings(prev => ({ ...prev, hasPin: true }));
    updateSecuritySettings({ hasPin: true });
    setPinMode(null);
    setSuccessMsg('PIN saved');
    setTimeout(() => setSuccessMsg(null), 3000);
  }

  // PIN remove
  async function handleRemovePin() {
    setRemoving(true);
    setError(null);
    try {
      const api = getApi();
      await api.post('/security/pin/remove');
      setSettings(prev => ({
        ...prev,
        hasPin: false,
        hasBiometric: false,
        lockTimeoutSeconds: 300,
      }));
      updateSecuritySettings({ hasPin: false, lockTimeoutSeconds: 300 });
      setConfirmRemove(false);
      setSuccessMsg('PIN removed — lock screen disabled');
      setTimeout(() => setSuccessMsg(null), 3000);
    } catch (err) {
      console.error('Remove PIN error:', err);
      setError('Could not remove PIN. Please try again.');
    } finally {
      setRemoving(false);
    }
  }

  // Lock timeout change
  async function handleTimeoutChange(e) {
    const newTimeout = parseInt(e.target.value);
    setTimeoutSaving(true);
    setError(null);
    try {
      const api = getApi();
      await api.patch('/security/settings', { lockTimeoutSeconds: newTimeout });
      setSettings(prev => ({ ...prev, lockTimeoutSeconds: newTimeout }));
      updateSecuritySettings({ lockTimeoutSeconds: newTimeout });
    } catch (err) {
      console.error('Timeout update error:', err);
      setError('Could not update lock timeout.');
    } finally {
      setTimeoutSaving(false);
    }
  }

  if (loading) {
    return <div className={styles.panel}><p className={styles.panelLoading}>Loading…</p></div>;
  }

  // If in PIN setup/change mode, show PinSetup component
  if (pinMode) {
    return (
      <div className={styles.panel}>
        <h2 className={styles.panelTitle}>
          {pinMode === 'change' ? 'Change PIN' : 'Set up PIN'}
        </h2>
        <PinSetup
          getApi={getApi}
          onSuccess={handlePinSuccess}
          onCancel={() => setPinMode(null)}
          mode={pinMode}
        />
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <h2 className={styles.panelTitle}>Security</h2>
      <p className={styles.panelHint}>
        Protect your memories with a PIN. When enabled, the app locks
        after a period of inactivity and requires your PIN to reopen.
      </p>

      {error && <p className={styles.securityError}>{error}</p>}
      {successMsg && <p className={styles.securitySuccess}>{successMsg}</p>}

      {/* ─── PIN Section ─── */}
      <div className={styles.securitySection}>
        <h3 className={styles.securitySectionTitle}>PIN Lock</h3>
        {settings?.hasPin ? (
          <div className={styles.securityRow}>
            <div className={styles.securityRowLeft}>
              <span className={styles.securityRowLabel}>PIN is set</span>
              <span className={styles.securityRowHint}>Your lock screen is active</span>
            </div>
            <div className={styles.securityRowActions}>
              <button
                className={styles.securityBtn}
                onClick={() => setPinMode('change')}
              >
                Change
              </button>
              {confirmRemove ? (
                <div className={styles.securityConfirmRow}>
                  <button
                    className={styles.securityBtnDanger}
                    onClick={handleRemovePin}
                    disabled={removing}
                  >
                    {removing ? 'Removing…' : 'Confirm remove'}
                  </button>
                  <button
                    className={styles.securityBtnMuted}
                    onClick={() => setConfirmRemove(false)}
                    disabled={removing}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <button
                  className={styles.securityBtnMuted}
                  onClick={() => setConfirmRemove(true)}
                >
                  Remove
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className={styles.securityRow}>
            <div className={styles.securityRowLeft}>
              <span className={styles.securityRowLabel}>No PIN set</span>
              <span className={styles.securityRowHint}>Your memories are not lock-protected</span>
            </div>
            <button
              className={styles.securityBtnPrimary}
              onClick={() => setPinMode('set')}
            >
              Set up PIN
            </button>
          </div>
        )}
      </div>

      {/* ─── Lock Timeout Section (only visible if PIN is set) ─── */}
      {settings?.hasPin && (
        <div className={styles.securitySection}>
          <h3 className={styles.securitySectionTitle}>Lock After</h3>
          <p className={styles.securitySectionHint}>
            How long the app can be in the background before the lock screen appears.
          </p>
          <select
            className={styles.securitySelect}
            value={settings.lockTimeoutSeconds}
            onChange={handleTimeoutChange}
            disabled={timeoutSaving}
          >
            {LOCK_TIMEOUT_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════════════════════
   RECENTLY DELETED PANEL — v3.4
   Lists soft-deleted memories with restore capability.
   Fetches GET /spaces/:id/memories/trash on mount.
   ═══════════════════════════════════════ */

const CATEGORY_ICONS = {
  voice: <RecordIcon size={16} />,
  text: <WriteIcon size={16} />,
  photo: <PhotoIcon size={16} />,
  video: <VideoIcon size={16} />,
};
const CATEGORY_ICON_FALLBACK = <WriteIcon size={16} />;

function RecentlyDeletedPanel({ spaceId, getApi, momentsEnabled = false }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [restoringId, setRestoringId] = useState(null); // composite key `${kind}:${id}`
  const [restoredId, setRestoredId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function loadTrash() {
      try {
        const api = getApi();
        // Always the memories trash; when moments are on, also the moments
        // trash (one entry per removed moment, with cover + pieceCount). Merge
        // and sort newest-removed first. Tag kind so restore hits the right path.
        const reqs = [api.get(`/spaces/${spaceId}/memories/trash`)];
        if (momentsEnabled) reqs.push(api.get(`/spaces/${spaceId}/moments/trash`));
        const [memData, momData] = await Promise.all(reqs);
        if (cancelled) return;
        const memItems = (memData?.items || []).map(it => ({ ...it, kind: 'memory' }));
        const momItems = momentsEnabled
          ? (momData?.items || []).map(it => ({ ...it, kind: 'moment' }))
          : [];
        const merged = [...memItems, ...momItems].sort(
          (a, b) => new Date(b.deletedAt) - new Date(a.deletedAt)
        );
        setItems(merged);
      } catch (err) {
        console.error('Trash load error:', err);
        if (!cancelled) setError('We weren’t able to load your removed memories. When you’re ready, please try again.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    loadTrash();
    return () => { cancelled = true; };
  }, [spaceId, getApi, momentsEnabled]);

  async function handleRestore(item) {
    const key = `${item.kind}:${item.id}`;
    if (restoringId) return;
    setRestoringId(key);
    try {
      const api = getApi();
      const path = item.kind === 'moment'
        ? `/moments/${item.id}/restore`
        : `/memories/${item.id}/restore`;
      await api.post(path);
      setItems(prev => prev.filter(it => `${it.kind}:${it.id}` !== key));
      setRestoredId(key);
      setTimeout(() => setRestoredId(null), 2000);
    } catch (err) {
      console.error('Restore error:', err);
      setError('We weren’t able to bring this memory back. When you’re ready, please try again.');
    } finally {
      setRestoringId(null);
    }
  }

  function formatDeleteDate(dateStr) {
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch { return ''; }
  }

  if (loading) {
    return <div className={styles.panel}><p className={styles.panelLoading}>Loading…</p></div>;
  }

  return (
    <div className={styles.panel}>
      <h2 className={styles.panelTitle}>Recently Deleted</h2>
      <p className={styles.panelHint}>
        Removed memories are kept here for 30 days. After that, they are permanently removed.
      </p>

      {error && <div className={styles.trashError}>{error}</div>}

      {restoredId && (
        <div className={styles.trashRestoredBanner}>Memory restored to your feed</div>
      )}

      {items.length === 0 && !error ? (
        <div className={styles.trashEmpty}>
          <p className={styles.trashEmptyTitle}>No removed memories</p>
          <p className={styles.trashEmptyText}>
            When you remove a memory, it will wait here for 30 days. You can bring it back anytime before then.
          </p>
        </div>
      ) : (
        <div className={styles.trashList}>
          {items.map(item => {
            const key = `${item.kind}:${item.id}`;
            const isMoment = item.kind === 'moment';
            const title = item.title
              || (!isMoment && item.note?.substring(0, 40))
              || (isMoment
                    ? (item.dayText || 'Memory')
                    : `${(item.category || 'Memory').charAt(0).toUpperCase() + (item.category || 'memory').slice(1)} memory`);
            return (
              <div key={key} className={styles.trashItem}>
                {isMoment && item.coverUrl ? (
                  <img src={item.coverUrl} alt="" className={styles.trashItemCover} />
                ) : (
                  <span className={styles.trashItemIcon}>
                    {isMoment
                      ? CATEGORY_ICON_FALLBACK
                      : (CATEGORY_ICONS[item.category?.toLowerCase()] || CATEGORY_ICON_FALLBACK)}
                  </span>
                )}
                <div className={styles.trashItemInfo}>
                  <span className={styles.trashItemTitle}>{title}</span>
                  <span className={styles.trashItemMeta}>
                    Removed {formatDeleteDate(item.deletedAt)}
                    {isMoment && ` · ${item.pieceCount} ${item.pieceCount === 1 ? 'piece' : 'pieces'}`}
                    {' · '}{item.daysRemaining} {item.daysRemaining === 1 ? 'day' : 'days'} remaining
                  </span>
                </div>
                <button
                  className={styles.trashRestoreBtn}
                  onClick={() => handleRestore(item)}
                  disabled={restoringId === key}
                >
                  {restoringId === key ? 'Restoring…' : 'Restore'}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════════════════════
   SECTION PARAM MAPPING (backward compat — unchanged)
   ═══════════════════════════════════════ */

function resolveInitialSection(sectionParam, hasSpaceId, isDesktop) {
  if (sectionParam === 'space') return 'space-info';
  if (sectionParam === 'feedback') return 'suggestions';
  if (sectionParam) return sectionParam;
  // v3.15 (B): desktop must never show a blank content pane - default to a section.
  // Space when a space is in context (footer gear always passes ?from), else Account.
  if (isDesktop) return hasSpaceId ? 'space-info' : 'account';
  return null; // mobile: menu-first (no preselection)
}

/* ═══════════════════════════════════════
   SETTINGS PAGE
   ═══════════════════════════════════════ */

export default function SettingsPage({ inOverlay = false }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const spaceId = searchParams.get('from');
  const { getAccessTokenSilently, user, logout } = useAuth0();
  const appState = useAppContext();

  const getApi = useCallback(
    () => createApiClient(getAccessTokenSilently),
    [getAccessTokenSilently]
  );

  // v3.10: Billing status needed at top level for nav item visibility
  const { billing } = useBillingStatus(getApi);

  /* v3.15 (B): desktop = viewport where .leftNav shows (CSS breakpoint is max-width:640px). */
  const isDesktopSettings = typeof window !== 'undefined'
    && window.matchMedia('(min-width: 641px)').matches;

  /* ─── Active nav section ─── */
  const [activeSection, setActiveSection] = useState(
    resolveInitialSection(searchParams.get('section'), !!spaceId, isDesktopSettings)
  );

  /* v3.3: Mobile settings sidebar — mirrors SpacePage sidebar pattern */
  /* v3.8: Opens automatically when no explicit section param (category list view) */
  const arrivedWithoutSection = !searchParams.get('section');
  const [settingsSidebarOpen, setSettingsSidebarOpen] = useState(arrivedWithoutSection && !isDesktopSettings); // v3.15 (B): desktop never auto-opens the mobile drawer

  const toggleSettingsSidebar = useCallback(() => {
    setSettingsSidebarOpen(prev => !prev);
  }, []);

  const closeSettingsSidebar = useCallback(() => {
    setSettingsSidebarOpen(false);
    if (arrivedWithoutSection) {
      navigate(-1);
    }
  }, [arrivedWithoutSection, navigate]);

  /* Select a section — also closes sidebar on mobile */
  const selectSection = useCallback((sectionId) => {
    setActiveSection(sectionId);
    setSettingsSidebarOpen(false);
  }, []);

  /* ─── Request form state (sub-panel of settings) ─── */
  const [requestType, setRequestType] = useState(null);
  const [requestResult, setRequestResult] = useState(null);
  const [requestSpaceName, setRequestSpaceName] = useState(null);

  function openRequestPanel(type, spaceName) {
    setRequestType(type || 'other');
    setRequestSpaceName(spaceName || null);
    setRequestResult(null);
    setActiveSection('request');
  }

  function handleRequestSuccess(result) {
    setRequestResult(result);
    setActiveSection('request-success');
  }

  function handleRequestCancel() {
    setActiveSection('account');
    setRequestType(null);
  }

  function handleRequestSuccessBack() {
    setActiveSection('account');
    setRequestType(null);
    setRequestResult(null);
  }

  // v2.4 (Fix 1): Read ?action= param
  const [initialAction] = useState(() => {
    const action = searchParams.get('action');
    if (action) {
      const cleanParams = new URLSearchParams(searchParams);
      cleanParams.delete('action');
      const cleanUrl = cleanParams.toString()
        ? `${window.location.pathname}?${cleanParams.toString()}`
        : window.location.pathname;
      window.history.replaceState(null, '', cleanUrl);
    }
    return action;
  });

  /* ─── Space data ─── */
  const [space, setSpace]               = useState(null);
  const [loadingSpace, setLoadingSpace] = useState(false);

  useEffect(() => {
    if (!spaceId) return;
    async function loadSpace() {
      setLoadingSpace(true);
      try {
        const api = getApi();
        const data = await api.get(`/spaces/${spaceId}`);
        setSpace(data);
      } catch (err) {
        console.error('SettingsPage: failed to load space:', err);
      } finally {
        setLoadingSpace(false);
      }
    }
    loadSpace();
  }, [spaceId, getApi]);

  /* ─── v3.6: Resolve space photo S3 key to CloudFront signed URL for backlink ─── */
  const [resolvedSpacePhotoUrl, setResolvedSpacePhotoUrl] = useState(null);

  useEffect(() => {
    if (!space?.photoUrl) {
      setResolvedSpacePhotoUrl(null);
      return;
    }
    let cancelled = false;
    async function resolve() {
      try {
        const api = getApi();
        const data = await api.get(`/media/playback/${space.photoUrl}`);
        if (!cancelled && data?.playbackUrl) {
          setResolvedSpacePhotoUrl(data.playbackUrl);
        }
      } catch (err) {
        console.error('SettingsPage: failed to resolve space photo:', err);
        if (!cancelled) setResolvedSpacePhotoUrl(null);
      }
    }
    resolve();
    return () => { cancelled = true; };
  }, [space?.photoUrl, getApi]);

  const handlePanelSave = useCallback((updatedSpace) => {
    setSpace((prev) => ({ ...prev, ...updatedSpace }));
  }, []);

  /* ─── Sign Out (now at SettingsPage level for sidebar) ─── */
  function handleSignOut() {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('ana_')) keysToRemove.push(key);
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
    logout({ logoutParams: { returnTo: window.location.origin } });
  }

  /* ─── Navigation ─── */
  function goBack() {
    if (spaceId) navigate(`/spaces/${spaceId}`);
    else navigate('/spaces');
  }

  function goToSpace() {
    if (spaceId) navigate(`/spaces/${spaceId}`);
  }

  /* ─── Nav items (v3.10: billing conditionally hidden via feature flag) ─── */
  const billingEnabled = billing?.billingEnabled !== false;
  const globalNavItems = [
    { id: 'account',  label: 'Account',       icon: <AccountIcon />,  section: 'global' },
    { id: 'security', label: 'Security',       icon: <ShieldIcon />,   section: 'global' },
    ...(billingEnabled ? [{ id: 'billing',  label: 'Plan & Billing', icon: <BillingIcon />,  section: 'global' }] : []),
  ];

  const spaceNavItems = spaceId ? [
    { id: 'space-info',        label: 'Space',            icon: <SpaceIcon />,        section: 'space' },
    { id: 'contributors',      label: 'Contributors',     icon: <ContributorsIcon />, section: 'space' },
    { id: 'reminders',         label: 'Reminders',        icon: <ReminderIcon />,     section: 'space' },
    { id: 'recently-deleted',  label: 'Recently Deleted', icon: <TrashIcon />,        section: 'space' },
  ] : [];

  const quickActionItems = [
    { id: 'need-help',    label: 'Need Help',    icon: <HelpIcon />,        section: 'quick' },
    { id: 'app-tour',     label: 'App Tour',     icon: <TourIcon />,        section: 'quick' },
    { id: 'suggestions',  label: 'Suggestions',  icon: <SuggestionsIcon />, section: 'quick' },
  ];

  const navItems = [...globalNavItems, ...spaceNavItems, ...quickActionItems];

  /* ─── Right panel content ─── */
  function renderPanel() {
    /* v3.7: need-help moved to Quick Actions — no longer gated by space loading */
    const isSpacePanel = ['space-info', 'contributors', 'reminders', 'recently-deleted'].includes(activeSection);

    if (isSpacePanel) {
      if (loadingSpace) {
        return <div className={styles.panel}><p className={styles.panelLoading}>Loading…</p></div>;
      }
      if (!space) {
        return <div className={styles.panel}><p className={styles.panelLoading}>Could not load space.</p></div>;
      }
    }

    switch (activeSection) {
      case 'account':
        return <AccountPanel user={user} appState={appState} getApi={getApi}
          onOpenRequest={(type) => openRequestPanel(type)} />;

      case 'security':
        return <SecurityPanel getApi={getApi} />;

      case 'request':
        return (
          <div className={styles.panel}>
            <h2 className={styles.panelTitle}>Submit a Request</h2>
            <RequestPanel
              initialType={requestType}
              spaceName={requestSpaceName}
              getApi={getApi}
              appState={appState}
              onSuccess={handleRequestSuccess}
              onCancel={handleRequestCancel}
              excludeTypes={['suggestion']}
            />
          </div>
        );

      case 'request-success':
        return requestResult
          ? (
            <div className={styles.panel}>
              <RequestSuccessPanel result={requestResult} onBack={handleRequestSuccessBack} />
            </div>
          )
          : <AccountPanel user={user} appState={appState} getApi={getApi}
              onOpenRequest={(type) => openRequestPanel(type)} />;

      case 'space-info':
        return (
          <div className={styles.panel}>
            <h2 className={styles.panelTitle}>Space</h2>
            <SpaceInfoPanel space={space} getApi={getApi} onSave={handlePanelSave} canSetGroupType={appState?.flags?.group_spaces_enabled === true && appState?.pilotRole === 'leader'} />
          </div>
        );

      case 'contributors':
        return (
          <div className={styles.panel}>
            <h2 className={styles.panelTitle}>Contributors</h2>
            <ContributorsPanel space={space} getApi={getApi} onSave={handlePanelSave} />
          </div>
        );

      case 'reminders':
        return (
          <div className={styles.panel}>
            <h2 className={styles.panelTitle}>Reminders</h2>
            <RemindersPanel space={space} getApi={getApi} onSave={handlePanelSave} />
          </div>
        );

      case 'need-help':
        return (
          <div className={styles.panel}>
            <h2 className={styles.panelTitle}>Need Help</h2>
            <p className={styles.panelHint}>
              If you have questions about this space or need a hand, we're here to help.
            </p>
            <RequestPanel
              initialType="other"
              spaceName={space?.name || null}
              getApi={getApi}
              appState={appState}
              onSuccess={handleRequestSuccess}
              onCancel={() => setActiveSection('need-help')}
              excludeTypes={['suggestion']}
            />
          </div>
        );

      case 'billing':
        return <BillingPanel spaceId={spaceId} navigate={navigate} getApi={getApi} initialAction={initialAction} />;

      case 'recently-deleted':
        return <RecentlyDeletedPanel spaceId={spaceId} getApi={getApi} momentsEnabled={appState.flags?.moments_enabled === true} />;

      case 'app-tour':
        return (
          <div className={styles.panel}>
            <h2 className={styles.panelTitle}>App Tour</h2>
            <p className={styles.panelHint}>
              Replay the getting started walkthrough to learn about key features.
            </p>
            <button
              className={styles.tourStartBtn}
              onClick={() => {
                if (spaceId) {
                  navigate(`/spaces/${spaceId}`, { state: { startTour: true } });
                }
              }}
              disabled={!spaceId}
            >
              Start tour
            </button>
            {!spaceId && (
              <p className={styles.panelHint} style={{ marginTop: 8 }}>
                Return to a space to start the tour.
              </p>
            )}
          </div>
        );

      case 'suggestions':
        return (
          <div className={styles.panel}>
            <SuggestionsPanel getApi={getApi} appState={appState} />
          </div>
        );

      default:
        return null;
    }
  }

  /* ─── Render ─── */
  return (
    <div className={inOverlay ? `${styles.page} ${styles.pageInOverlay}` : styles.page}>

      <header className={styles.header}>
        {/* v3.3: Mobile: hamburger opens sidebar (on left side).
            Desktop: back arrow navigates to space. Menu hidden on desktop. */}
        <button
          className={styles.menuBtn}
          onClick={toggleSettingsSidebar}
          aria-label="Open settings menu"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        {inOverlay ? (
          <div className={styles.headerSpacer} aria-hidden="true" />
        ) : (
          <button className={styles.backBtn} onClick={goBack} aria-label="Go back">
            <BackIcon />
          </button>
        )}
        <h1 className={styles.title}>Settings</h1>
        {inOverlay ? (
          <button className={styles.closeBtn} onClick={() => navigate(-1)} aria-label="Close settings">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        ) : (
          <div className={styles.headerSpacer} aria-hidden="true" />
        )}
      </header>

      {/* v3.3: Mobile settings sidebar — slides in from left */}
      {settingsSidebarOpen && (
        <>
          <div className={styles.settingsSidebarBackdrop} onClick={closeSettingsSidebar} />
          <aside className={styles.settingsSidebar}>
            <div className={styles.settingsSidebarHeader}>
              <h2 className={styles.settingsSidebarTitle}>Settings</h2>
              <button
                className={styles.settingsSidebarClose}
                onClick={inOverlay ? () => navigate(-1) : closeSettingsSidebar}
                aria-label={inOverlay ? 'Close settings' : 'Close menu'}
              >✕</button>
            </div>

            {/* v3.3→v3.6: Space back link — returns to the space, now with photo */}
            {!inOverlay && spaceId && space && (
              <button className={styles.settingsSidebarSpaceBack} onClick={goToSpace}>
                <span className={styles.settingsSidebarSpaceArrow}>←</span>
                {resolvedSpacePhotoUrl ? (
                  <img
                    src={resolvedSpacePhotoUrl}
                    alt=""
                    className={styles.settingsSidebarSpacePhoto}
                    onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }}
                  />
                ) : null}
                <span
                  className={styles.settingsSidebarSpaceInitial}
                  style={resolvedSpacePhotoUrl ? { display: 'none' } : undefined}
                >
                  {(space.name || '?').charAt(0).toUpperCase()}
                </span>
                <span className={styles.settingsSidebarSpaceName}>{space.name}</span>
              </button>
            )}

            <div className={styles.settingsSidebarItems}>
              {/* v3.7: Section-boundary rendering with GLOBAL/SPACE/QUICK ACTIONS headers */}
              {navItems.map((item, i) => {
                const prevSection = i > 0 ? navItems[i - 1].section : null;
                const showHeader = item.section !== prevSection;
                const headerLabels = { global: 'GLOBAL', space: 'SPACE', quick: 'QUICK ACTIONS' };
                const headerIds = { global: 'sidebar-section-global', space: 'sidebar-section-space', quick: 'sidebar-section-quick' };

                return (
                  <div key={item.id}>
                    {showHeader && (
                      <div
                        className={styles.settingsSidebarSectionLabel}
                        id={headerIds[item.section]}
                      >
                        {headerLabels[item.section]}
                      </div>
                    )}
                    <button
                      className={`${styles.settingsSidebarItem} ${activeSection === item.id ? styles.settingsSidebarItemActive : ''} ${item.disabled ? styles.settingsSidebarItemDisabled : ''}`}
                      onClick={() => !item.disabled && selectSection(item.id)}
                      aria-disabled={item.disabled || undefined}
                      aria-label={item.disabled ? `${item.label} ${item.hint || ''}`.trim() : undefined}
                    >
                      <span className={styles.navIcon}>{item.icon}</span>
                      <span className={styles.navLabel}>
                        {item.label}{item.hint ? ` ${item.hint}` : ''}
                      </span>
                    </button>
                  </div>
                );
              })}

              <div className={styles.settingsSidebarSignOut}>
                <button className={styles.settingsSidebarItem} onClick={handleSignOut}>
                  <span className={styles.navIcon}><SignOutIcon /></span>
                  <span className={styles.navLabel}>Sign out</span>
                </button>
              </div>
            </div>
          </aside>
        </>
      )}

      <div className={styles.body}>

        <nav className={styles.leftNav} aria-label="Settings sections">

          {/* v3.6: Space back link with photo */}
          {!inOverlay && spaceId && space && (
            <button className={styles.spaceBackLink} onClick={goToSpace}>
              <span className={styles.spaceBackArrow}>←</span>
              {resolvedSpacePhotoUrl ? (
                <img
                  src={resolvedSpacePhotoUrl}
                  alt=""
                  className={styles.spaceBackPhoto}
                  onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }}
                />
              ) : null}
              <span
                className={styles.spaceBackInitial}
                style={resolvedSpacePhotoUrl ? { display: 'none' } : undefined}
              >
                {(space.name || '?').charAt(0).toUpperCase()}
              </span>
              <span className={styles.spaceBackName}>{space.name}</span>
            </button>
          )}

          {/* v3.7: Section-boundary rendering with GLOBAL/SPACE/QUICK ACTIONS headers */}
          {navItems.map((item, i) => {
            const prevSection = i > 0 ? navItems[i - 1].section : null;
            const showHeader = item.section !== prevSection;
            const headerLabels = { global: 'GLOBAL', space: 'SPACE', quick: 'QUICK ACTIONS' };
            const headerIds = { global: 'nav-section-global', space: 'nav-section-space', quick: 'nav-section-quick' };

            return (
              <div key={item.id}>
                {showHeader && (
                  <div
                    className={styles.navSectionLabel}
                    id={headerIds[item.section]}
                  >
                    {headerLabels[item.section]}
                  </div>
                )}
                <button
                  className={`${styles.navItem} ${activeSection === item.id ? styles.navItemActive : ''} ${item.disabled ? styles.navItemDisabled : ''}`}
                  onClick={() => !item.disabled && selectSection(item.id)}
                  aria-disabled={item.disabled || undefined}
                  aria-label={item.disabled ? `${item.label} ${item.hint || ''}`.trim() : undefined}
                >
                  <span className={styles.navIcon}>{item.icon}</span>
                  <span className={styles.navLabel}>
                    {item.label}{item.hint ? ` ${item.hint}` : ''}
                  </span>
                  {!item.disabled && <span className={styles.navChevron}><ChevronIcon /></span>}
                </button>
              </div>
            );
          })}

          {/* Sign Out — always last in sidebar */}
          <div className={styles.signOutNavWrapper}>
            <button className={styles.signOutNavItem} onClick={handleSignOut}>
              <span className={styles.navIcon}><SignOutIcon /></span>
              <span className={styles.navLabel}>Sign out</span>
            </button>
          </div>
        </nav>

        <div className={styles.rightPanel}>
          {renderPanel()}
        </div>

      </div>
    </div>
  );
}
